import { useMutation } from '@tanstack/react-query';
import { post } from '../../utils/networking';

interface InstallTeamsChannelParams {
  trustpulseTeamId: number;
  teamsTeamId: string;
  teamsChannelId: string;
  teamsWorkspaceId: number;
}

interface InstallTeamsChannelResponse {
  success: boolean;
  channelName: string;
  distributionChannelId: number;
}

const installTeamsChannel = async (params: InstallTeamsChannelParams): Promise<InstallTeamsChannelResponse> => {
  return post<InstallTeamsChannelResponse>('/api/integrations/teams/install', params);
};

export const useInstallTeamsChannel = () => {
  return useMutation({
    mutationFn: installTeamsChannel,
  });
};
